function openSuperSizedImages(){
  if(document.getElementById('supersized-images')){
    let superSizedImages = document.getElementById('supersized-images');
    superSizedImages.classList.remove('closed');
    document.getElementsByTagName('body')[0].classList.add('no-scroll');
  }
}

function closeSuperSizedImages(){
  if(document.getElementById('supersized-images')){
    let superSizedImages = document.getElementById('supersized-images');
    superSizedImages.classList.add('closed');
    document.getElementsByTagName('body')[0].classList.remove('no-scroll');
  }
}

export function productSliderScripts() {
  if(document.getElementById('product-images-slider')){
    const deltaX = 12;
    const deltaY = 30;
    const productImageElement = document.getElementById('product-images-slider');
    const superSizeCloser =document.getElementById('supersize-closer');
    let startX;
    let startY;

    productImageElement.addEventListener('click',function(event){
      openSuperSizedImages();
    });

    superSizeCloser.addEventListener('click',function(event){
    closeSuperSizedImages();
    });

  }
}
